export const meta = {
  id: 'C01',
  slug: 'cha',
  title: 'Entenda o CHA',
  description: 'Conheça a lógica Conhecimento, Habilidade e Atitude usada pelo Personagrama para transformar aprendizado em desenvolvimento observável.',
  profile: 'student',
  category: 'conceitos',
  type: 'concept',
  status: 'published',
  order: 190,
  keywords: ['cha', 'conhecimento', 'habilidade', 'atitude', 'competência', 'desenvolvimento', 'aprendizado'],
  previous: 'A13.1',
  next: 'C02',
  related: ['A03', 'A11', 'C02'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Entenda o CHA

O Personagrama utiliza o **CHA — Conhecimento, Habilidade e Atitude** como uma referência para compreender desenvolvimento de forma mais completa.

Aprender algo é importante, mas desenvolvimento acontece quando o conhecimento também pode ser aplicado e demonstrado no comportamento.

## Conhecimento

É aquilo que você **sabe e compreende**.

Pode aparecer em conteúdos, estudos, aulas, testes, reflexões e outras experiências de aprendizagem.

## Habilidade

É aquilo que você **consegue fazer na prática**.

A habilidade aparece quando o conhecimento é aplicado em uma situação real ou simulada e produz uma execução observável.

## Atitude

É a forma como você **age e sustenta comportamentos** no cotidiano.

Atitude envolve postura, constância, iniciativa, responsabilidade e outros comportamentos relacionados à competência em desenvolvimento.

## Como o CHA aparece no Personagrama

**Conhecimento → Habilidade → Atitude → Acompanhamento → Evolução.**

<Diagram kind="cha" caption="O CHA ajuda a observar desenvolvimento para além do conteúdo consumido: saber, aplicar, sustentar comportamentos e acompanhar a evolução." />

Treinamentos ajudam a ampliar Conhecimento. Atividades e Evidências ajudam a demonstrar Habilidade e Atitude. Mentoria e acompanhamento ajudam a interpretar o que aconteceu e orientar o próximo passo.

<Callout type="concept">
  O objetivo não é apenas saber mais. É aprender, aplicar, demonstrar e evoluir.
</Callout>